import React from 'react';
import PropTypes from 'prop-types';
import './ButtonIcon.css';

function ButtonIcon({ onClick, icon, label, className, classNameLabel = 'type-secondary', iconPosition = 'left', style }) {
  return (
    <div onClick={onClick} className={`flexCenter bp-button button-icon round ${className}`} style={style} >
      {iconPosition === 'left' && icon}
      <span className={`type-small ${classNameLabel}`}>{label}</span>
      {iconPosition === 'right' && icon}
    </div>
  );
}

ButtonIcon.propTypes = {
  onClick: PropTypes.func,
  icon: PropTypes.element.isRequired,
  iconPosition: PropTypes.string,
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  classNameLabel: PropTypes.string,
  style: PropTypes.object,
}

export default ButtonIcon;
